module.exports = __webpack_public_path__ + "static/media/4.bceccc9a.svg";